import { EEkycStatuesesApi, EEkycStatuses } from 'types/entities/users';

const mapEkycStatus = (ekycStatus: EEkycStatuesesApi): EEkycStatuses => {
    switch (ekycStatus) {
        case EEkycStatuesesApi.EKYC_STATUS_UNVERIFIED:
            return EEkycStatuses.UNVERIFIED;
        case EEkycStatuesesApi.EKYC_STATUS_PROCESSING:
            return EEkycStatuses.PROCESSING;
        case EEkycStatuesesApi.EKYC_STATUS_VERIFIED:
            return EEkycStatuses.VERIFIED;
        case EEkycStatuesesApi.EKYC_STATUS_REJECTED:
            return EEkycStatuses.REJECTED;
        default:
            return EEkycStatuses.UNVERIFIED;
    }
};

export default mapEkycStatus;
